// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"217":"76fe162b92635ee81e0e","218":"9b2c5a5c44ce0b41b1c8","231":"b3c49111b292e6689b5c","589":"0a6edb02c9224291d2b9","691":"c0af73d2112cba3e4c43","774":"4188f66c5ff0d4654929"}[chunkId] + ".js";
};